



























import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BaseOverlinedHeading from './BaseOverlinedHeading.vue';
import BaseCard from './BaseCard.vue';
import cards from '../store/why-you-need-cards';


@Component({
    components: {
        BaseOverlinedHeading,
        BaseCard
    }
})
export default class TheHomePageWhyYouNeed extends Vue {
    cards = cards;

    requireImage(img: string): void {
        console.log(img);
        return require("../assets/images/icons/" + img);
    }
}
